import { render, staticRenderFns } from "./fundQuery.vue?vue&type=template&id=12faaaf4&scoped=true&"
import script from "./fundQuery.vue?vue&type=script&lang=js&"
export * from "./fundQuery.vue?vue&type=script&lang=js&"
import style0 from "./fundQuery.vue?vue&type=style&index=0&id=12faaaf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12faaaf4",
  null
  
)

export default component.exports